<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <label tag="div">Código</label>
      <b-form-input
        type="text"
        placeholder="Código"
        v-model="form.cd"
        name="cd"
      >
      </b-form-input>
      <b-form-feedback
        v-text="form.errors.get('cd')"
        v-if="form.errors.has('cd')"
      ></b-form-feedback>

      <label tag="div">Descrição</label>
      <b-form-input
        type="text"
        placeholder="Descrição"
        v-model="form.descr"
        name="descr"
      >
      </b-form-input>
      <b-form-feedback
        v-text="form.errors.get('descr')"
        v-if="form.errors.has('descr')"
      ></b-form-feedback>

      <label tag="div">Status</label>
      <multiselect
        v-model="statusSelected"
        :options="optionsLivStatus"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('status.value')"
        v-if="form.errors.has('status.value')"
      ></b-form-feedback>

      <b-form-text>Cliente</b-form-text>
      <multiselect
        v-model="pessoaSelected"
        :options-limit="300"
        :limit="1"
        :limit-text="limitText"
        :options="optionsPessoa"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Cliente ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
        :searchable="true"
        :loading="isLoadingCliente"
        @search-change="listaClientes"
      ></multiselect>
      <b-form-feedback
        class="text-danger"
        v-text="form.errors.get('cliente')"
        v-if="form.errors.has('cliente')"
      ></b-form-feedback>

      <label tag="div">Unidade</label>
      <multiselect
        v-model="unidadeSelected"
        :options="optionsUnidade"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('unidade.value')"
        v-if="form.errors.has('unidade.value')"
      ></b-form-feedback>

      <label>Região</label>
      <multiselect
        v-model="regiao"
        :options="optionsRegiao"
        track-by="value"
        label="label"
        :limit="10"
        :multiple="true"
        :clear-on-select="false"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('regiao')"
        v-if="form.errors.has('regiao')"
      ></b-form-feedback>

      <label>Municipio</label>
      <multiselect
        v-model="municipio"
        :options="optionsMunicipio"
        track-by="value"
        label="label"
        :limit="10"
        :multiple="true"
        :clear-on-select="false"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('municipio')"
        v-if="form.errors.has('municipio')"
      ></b-form-feedback>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      isLoadingCliente: false,
      statusSelected: [],
      unidadeSelected: [],
      pessoaSelected: [],
      errors_array: [],
      optionsLivStatus: [],
      optionsPessoa: [],
      optionsUnidade: [],
      regiao: [],
      municipio: [],
      optionsRegiao: [],
      optionsMunicipio: [],
      form: new Form({
        cd: "",
        descr: "",
        pessoa_id: "",
        status: "",
        unidade_id: "",
        regiao: [],
        municipio: [],
        pespar_id: "",
        tipo: ""
      }),
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "cd",
          title: "Código",
          sortField: "cd",
        },
        {
          name: "descr",
          title: "Descrição",
          sortField: "descr",
        },
        {
          name: "nome",
          title: "Nome",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    statusSelected(obj) {
      this.form.status = obj.value;
    },
    unidadeSelected(obj) {
      this.form.unidade_id = obj.value;
    },
    pessoaSelected(obj) {
      this.form.pessoa_id = obj.value;
    },
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.pespar_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.unidadeSelected = [];
      this.statusSelected = [];
      this.pessoaSelected = [];
      this.municipio = [];
      this.regiao = [];
      this.errors_array = "";
      this.errors_array = [];
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.unidadeSelected = [];
      this.statusSelected = [];
      this.pessoaSelected = [];
      this.municipio = [];
      this.regiao = [];
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.statusSelected = {
        label: data.status.descr,
        value: data.status.valor,
      };
      this.pessoaSelected = {
        label:
          "PJ -" +
          data.pessoa.cd +
          " - " +
          data.pessoa.pessoa_juridica.razao_social +
          " - " +
          this.onFormataCnpj(
            data.pessoa.pessoa_juridica.cnpj_base,
            data.pessoa.pessoa_juridica.cnpj_filial,
            data.pessoa.pessoa_juridica.cnpj_digito
          ),
        pessoa_id: data.pessoa.pessoa_id,
        value: data.pessoa.pessoa_id,
      };
      if (data.unidade_geral != null) {
        this.unidadeSelected = {
          label: data.unidade_geral.cd + " - " + data.unidade_geral.descr,
          value: data.unidade_geral.unidade_id,
        };
      }
      if (data.pessoa_parceira_regiao.length > 0) {
        data.pessoa_parceira_regiao.forEach((obj) => {
          this.regiao.push({
            label: obj.regiao.cd + " - " + obj.regiao.descr,
            value: obj.regiao_id,
            regiao_id: obj.regiao_id,
            status: obj.status.valor,
          });
        });
      }
      if (data.pessoa_parceira_municipio.length > 0) {
        data.pessoa_parceira_municipio.forEach((obj) => {
          this.municipio.push({
            label: obj.municipio.nome + " - " + obj.municipio.uf.cd,
            value: obj.municipio_id,
            municipio_id: obj.municipio_id,
            status: obj.status.valor,
          });
        });
      }
      this.form.pespar_id = id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.regiao = this.regiao;
      this.form.municipio = this.municipio;
      this.form.tipo = 2;
      this.form
        .put("/api/" + this.rota + "/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.regiao = this.regiao;
      this.form.municipio = this.municipio;
      this.form.tipo = 2;
      this.form
        .patch("/api/" + this.rota + "/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/" + this.rota + "/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    listaClientes(search) {
      if (search.length >= 3) {
        this.isLoadingPessoa = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then((response) => {
            this.optionsPessoa = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsPessoa.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ),
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsPessoa.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsPessoa.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingPessoa = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    getLivGeral() {
      this.helpForm
        .get("/api/unidadeparceira/jsonlistgeral")
        .then((response) => {
          response.pessoa_parceira_status.forEach((obj) => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });
          response.regiao.forEach((obj) => {
            this.optionsRegiao.push({
              label: obj.cd + " - " + obj.descr,
              value: obj.regiao_id,
              regiao_id: obj.regiao_id,
              status: 1,
            });
          });
          response.municipio.forEach((obj) => {
            this.optionsMunicipio.push({
              label: obj.nome + " - " + obj.uf.cd,
              value: obj.municipio_id,
              municipio_id: obj.municipio_id,
              status: 1,
            });
          });
          response.unidade.forEach((obj) => {
            this.optionsUnidade.push({
              label: obj.cd + " - " + obj.descr,
              value: obj.unidade_id,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
